export enum ApScheduledStatus {
    notScheduled = 'Not Scheduled',
    scheduled = 'Scheduled',
    scheduleError = 'Scheduling Error',
}
